

























































































import { Component, Vue } from 'vue-property-decorator';
import DeleteAccount from '@/components/profile/DeleteAccount.vue';
import Information from '@/components/profile/information/Information.vue';
import Container from '@/components/profile/Container.vue';
import UserMenu from '@/components/courses/UserMenu.vue';
import { localize, toast } from '@easygenerator/fragment-sdk';

const UPDATE_AVATAR_URL = 'user/updateAvatarUrl';

@Component({
  components: { DeleteAccount, Container, UserMenu, Information }
})
export default class Profile extends Vue {
  activeTab = 'personalInformation';

  isPopoverOpen = false;

  previousFocusedElement: HTMLElement | null = null;

  handlePopoverOpen() {
    this.previousFocusedElement = document.activeElement as HTMLElement;
    this.isPopoverOpen = true;
    this.$emit('popover:open');
  }

  handlePopoverClose() {
    this.isPopoverOpen = false;
    this.$emit('popover:close');

    this.$nextTick(() => {
      if (this.previousFocusedElement) {
        this.previousFocusedElement.focus();
      }
    });
  }

  get user() {
    return this.$store.getters['user/user'];
  }

  get userLoading() {
    return this.$store.getters['app/userLoading'];
  }

  get isPersonalInfoActive() {
    return this.activeTab === 'personalInformation';
  }

  get isSettingsActive() {
    return this.activeTab === 'settings';
  }

  onTabChanged(activeTab: string) {
    this.activeTab = activeTab;
  }

  onBack() {
    if (this.isPersonalInfoActive) {
      (this.$refs.informationRef as InstanceType<typeof Information>).handleBack();
    } else {
      this.$router.push({ name: 'Dashboard' });
    }
  }

  onUploadError(e: Error) {
    toast.error(e.message);
  }

  onUploadSuccess(imageUrl: string) {
    this.$store.dispatch(UPDATE_AVATAR_URL, imageUrl);
    toast.success(localize('allChangesAreSaved'));
  }
}
